import { message, Row } from "antd";
import React from 'react';
import firebase from "firebase/compat/app";
import _ from 'lodash';
import momentTZ from 'moment-timezone';
import moment from "moment-timezone";

export { isSupportManager, isSupportLead, isSupportLead2, isSupportAgent, isSupportAgent2, isSupportAgent3, isDev, isFurnishingAdmin, isSupportEngineer } from '../helpers/roleStore';

export const getQueryParams = (params = {}) => {
    let qs = '';
    _.each(params, (val, key) => {
        if (val) {
            qs += `${key}=${val.trim()}&`;
        }
    });
    return qs;
}

export const allFieldsNull = (fields = []) => {
    let notEmpty = false;
    for (let i = 0; i < fields.length; i++) {
        if (!!fields[i]) {
            notEmpty = true;
            break;
        }
    }
    return !notEmpty;

}

export const convertCentsIntoDollar = (num) => {
    if (num !== null && num !== undefined) {
        let dollars = num / 100;
        return formatToDollar(dollars);
    } else {
        return null;
    }
}

export const formatToDollar = (dollarsNum) => {
    if (dollarsNum !== null && dollarsNum !== undefined) {
        return dollarsNum.toLocaleString("en-US", { style: "currency", currency: "USD" });
    } else {
        return null;
    }
};

// export function useRoleHelpers() {
//     const { userRoles } = useAuth();
//
//     // e.g. replicate your logic
//     const isSupportManager = () => userRoles.includes('ROLE_SUPPORT_MANAGER');
//     const isSupportLead = () => userRoles.includes('ROLE_SUPPORT_LEAD');
//     // etc...
//
//     return { isSupportManager, isSupportLead /* ... */ };
// }


const getUserRoles = () => {
    const rolesString = localStorage.getItem('user_roles');
    return rolesString ? JSON.parse(rolesString) : [];
}

const hasRole = (roles, validRoles) => {
    return roles.some(role => validRoles.some(validRole => role.indexOf(validRole) > -1));
}

// export const isSupportAgent2 = () => {
//     const roles = getUserRoles();
//     return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD', 'SUPPORT_AGENT_3', 'SUPPORT_AGENT_2']);
// }
//
// export const isSupportAgent3 = () => {
//     const roles = getUserRoles();
//     return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD', 'SUPPORT_AGENT_3']);
// }
//
// export const isSupportLead = () => {
//     const roles = getUserRoles();
//     return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD']);
// }
//
//
//  export const isSupportManager = () => {
//      const roles = getUserRoles();
//      return hasRole(roles, ['SUPPORT_MANAGER']);
//  }
//
// export const isSupportAgent = () => {
//     const roles = getUserRoles();
//     return hasRole(roles, ['SUPPORT_MANAGER', 'SUPPORT_LEAD', 'SUPPORT_AGENT_3', 'SUPPORT_AGENT_2', 'SUPPORT_AGENT_1']);
// }

export function convertUTCDateToLocalDate(date, includeTime) {
    let dateTime;
    let zoneVal = momentTZ()
        .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
        .format('z');
    let timeZone = momentTZ.tz.guess();
    const guessedName = momentTZ.tz(timeZone).zoneName();
    if (guessedName !== zoneVal) {
        console.log('There may be some issue with your timezone');
    }
    if (includeTime) {
        dateTime = momentTZ
            .tz(momentTZ(date), timeZone).format('YYYY-MM-DD hh:mm a');
    } else {
        dateTime = momentTZ
            .tz(momentTZ(date), timeZone).format('YYYY-MM-DD');
    }
    return dateTime;
}

export function parseUnixEpochToReadableTimestamp(epoch) {
    return moment.unix(epoch).utc().format('YYYY-MM-DD HH:mm:ss UTC');
}

export function formatUTCDate(date, includeTime) {
    let dateTime;
    if (includeTime) {
        dateTime = moment(date).utc().format('YYYY-MM-DD HH:mm:ss UTC');
    } else {
        dateTime = moment(date).utc().format('YYYY-MM-DD');
    }
    return dateTime;
}

export function formatDate(date, includeTime, toLocal = false) {
    if (!date) return null;
    if (toLocal) {
        return convertUTCDateToLocalDate(date, includeTime);
    } else {
        return formatUTCDate(date, includeTime);
    }
}

export function formatArrayTags(data) {
    return <Row style={{ flexWrap: 'wrap', display: 'flex' }}>
        {data.map((_elem) => {
            return <span className={'custom-tag-element'}>{_elem}</span>
        })}
    </Row>
}

export function formatLicenseVersion(licenseVersion) {
    return licenseVersion
        .replace(/_/g, ' ')
        .replace(/com.meeetava.avaapp/g, '')
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();
}
// The furnishing (tradeline) account reported to the bureaus for a product, from the furnishing data already loaded.
// Tried in order: one of the product's ids; then the product's opening date against the tradeline's open date
// (closest within 3 days, and only when that picks one tradeline); then, when the user has only one such product
// and one tradeline, that tradeline. Otherwise nothing, so a wrong number is never shown.
export function findFurnishingAccount(furnishingAccounts = [], productIds = []) {
    // Only an exact product ID match counts. Guessing by open date or by "the only account"
    // could show another product's tradeline, so an unmatched product stays unknown.
    const ids = (productIds || []).filter(Boolean).map(String);
    if (ids.length === 0) return null;
    return (furnishingAccounts || []).find((account) => account?.productId != null && ids.includes(String(account.productId))) || null;
}
// The newest Save & Build loan. loanDetails holds every loan type (for example micro loans),
// so only the IDs of the customer's Save & Build plans are considered.
export function getLatestLoan(loanDetails, saveAndBuildLoanIds = []) {
    const ids = (saveAndBuildLoanIds || []).filter(Boolean).map(String);
    if (ids.length === 0) return null;
    const loans = Object.values(loanDetails || {})
        .map((entry) => entry?.loanDetails)
        .filter((loan) => loan && ids.includes(String(loan.id)));
    return loans.sort((a, b) => new Date(b.createTs || 0) - new Date(a.createTs || 0))[0] || null;
}


// Save & Build is never "charged off" in Admin: Ava calls it a write off.
// Only changes what is shown; the status values sent to the backend stay the same.
export const toWriteOff = (status) => typeof status === "string"
  ? status.replace(/CHARGED?_OFF/g, "WRITE OFF").replace(/WRITE OFF_/g, "WRITE OFF ")
  : status;
